import React from 'react';
import { Clock, Zap, Shield, MessageSquare } from 'lucide-react';
import AnimateOnScroll from './ui/AnimateOnScroll';

const benefits = [
  {
    id: 1,
    title: 'פחות טרחה טכנולוגית',
    description: 'אנחנו מטפלים בכל ההיבטים הטכניים, כך שתוכל להתמקד בניהול העסק שלך.',
    icon: Shield,
  },
  {
    id: 2,
    title: 'חיסכון בזמן',
    description: 'אוטומציה של תהליכים חוזרים ומייגעים, לפעולה מהירה ויעילה.',
    icon: Clock,
  },
  {
    id: 3,
    title: 'פשטות ושקט נפשי',
    description: 'פתרונות קלים לשימוש שלא דורשים ידע טכני מעמיק.',
    icon: Zap,
  },
  {
    id: 4,
    title: 'תמיכה אישית',
    description: 'ליווי מתמשך והדרכה בכל שלב, תמיד זמינים לשאלות ולפתרון בעיות.',
    icon: MessageSquare,
  },
];

const BenefitsSection = () => {
  return (
    <section id="benefits" className="py-20">
      <div className="section-container w-full max-w-full px-4 md:px-10">
        <AnimateOnScroll animation="animate-fade-in">
          <h2 className="section-title text-tech-darkGray">ערך מוסף לעסק שלך</h2>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
          {benefits.map((benefit, index) => (
            <AnimateOnScroll 
              key={benefit.id} 
              animation="animate-fade-in" 
              delay={index * 150}
            >
              <div className="flex gap-6 items-start">
                <div className="w-16 h-16 bg-tech-lightBlue rounded-lg flex items-center justify-center flex-shrink-0">
                  <benefit.icon className="w-8 h-8 text-tech-blue" />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-3 text-tech-darkGray">{benefit.title}</h3>
                  <p className="text-gray-600">{benefit.description}</p>
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;